/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncConfig
 */
export interface SyncConfig {
    /**
     * ID der Quell-Datenbank
     * @type {string}
     * @memberof SyncConfig
     */
    sourceDbId?: string;
    /**
     * Synchronisations-Modus
     * @type {string}
     * @memberof SyncConfig
     */
    syncMode?: SyncConfigSyncModeEnum;
    /**
     * Verhalten bei GEAENDERTEN Quell-Datensaetzen beim Datenabruf: NO_UPDATE = nicht aktualisieren (nur neue); KEEP_IF_LOCALLY_CHANGED = aktualisieren, ausser der Empfaenger hat die Kopie veraendert; ADD_AS_NEW = geaenderte Version zusaetzlich als neuer Datensatz liefern; OVERWRITE = Kopie einfach ueberschreiben.
     * @type {string}
     * @memberof SyncConfig
     */
    syncUpdateMode?: SyncConfigSyncUpdateModeEnum;
    /**
     * Ob beim automatischen Datenabruf / manuellen "Aktualisieren" NEUE Quell-Datensaetze automatisch uebernommen werden. true/null = ja (bisheriges Verhalten); false = nur bereits abgerufene aktualisieren.
     * @type {boolean}
     * @memberof SyncConfig
     */
    syncPullNewEntries?: boolean;
    /**
     * Welche Ausgaben geliefert werden: ALL/null = alle (bisher); WITH_ARTICLES = nur mit abgerufenem Artikel (Datums-Bucket); WITH_ARTICLES_AND_FUTURE = zusaetzlich zukuenftige Ausgaben.
     * @type {string}
     * @memberof SyncConfig
     */
    syncEditionMode?: SyncConfigSyncEditionModeEnum;
}


/**
 * @export
 */
export const SyncConfigSyncModeEnum = {
    Manual: 'MANUAL',
    Automatic: 'AUTOMATIC'
} as const;
export type SyncConfigSyncModeEnum = typeof SyncConfigSyncModeEnum[keyof typeof SyncConfigSyncModeEnum];

/**
 * @export
 */
export const SyncConfigSyncUpdateModeEnum = {
    NoUpdate: 'NO_UPDATE',
    KeepIfLocallyChanged: 'KEEP_IF_LOCALLY_CHANGED',
    AddAsNew: 'ADD_AS_NEW',
    Overwrite: 'OVERWRITE'
} as const;
export type SyncConfigSyncUpdateModeEnum = typeof SyncConfigSyncUpdateModeEnum[keyof typeof SyncConfigSyncUpdateModeEnum];

/**
 * @export
 */
export const SyncConfigSyncEditionModeEnum = {
    All: 'ALL',
    WithArticles: 'WITH_ARTICLES',
    WithArticlesAndFuture: 'WITH_ARTICLES_AND_FUTURE'
} as const;
export type SyncConfigSyncEditionModeEnum = typeof SyncConfigSyncEditionModeEnum[keyof typeof SyncConfigSyncEditionModeEnum];


/**
 * Check if a given object implements the SyncConfig interface.
 */
export function instanceOfSyncConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SyncConfigFromJSON(json: any): SyncConfig {
    return SyncConfigFromJSONTyped(json, false);
}

export function SyncConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceDbId': !exists(json, 'sourceDbId') ? undefined : json['sourceDbId'],
        'syncMode': !exists(json, 'syncMode') ? undefined : json['syncMode'],
        'syncUpdateMode': !exists(json, 'syncUpdateMode') ? undefined : json['syncUpdateMode'],
        'syncPullNewEntries': !exists(json, 'syncPullNewEntries') ? undefined : json['syncPullNewEntries'],
        'syncEditionMode': !exists(json, 'syncEditionMode') ? undefined : json['syncEditionMode'],
    };
}

export function SyncConfigToJSON(value?: SyncConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sourceDbId': value.sourceDbId,
        'syncMode': value.syncMode,
        'syncUpdateMode': value.syncUpdateMode,
        'syncPullNewEntries': value.syncPullNewEntries,
        'syncEditionMode': value.syncEditionMode,
    };
}

